//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
let d=[[[0,"AssemblyValidationProperties",1,0],[0,"Author",1,0],[0,"Authorization",1,0],[0,"BsplineTol",1,0],[0,"CloudOfPointsProperties",1,0],[0,"ColorAndLayers",1,0],[0,"Company",1,0],[0,"Csys",1,"CoordinateSystem",0],[0,"Description",1,0],[0,"EntityNames",1,0],[0,"ExportAs",1,0],[0,"ExportConvergentAs",1,0],[0,"ExportExtRef",1,0],[0,"ExportExtRefStructureAs",1,0],[0,"ExportFrom",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"ExportSolidsAndSurfacesAs",1,0],[0,"FileSaveFlag",1,0],[0,"GeometricValidationProperties",1,0],[0,"InputFile",1,0],[0,"KinematicApp",1,0],[0,"LayerMask",1,0],[0,"Material",1,0],[1,"ObjectTypes",0,"ObjectTypeSelector",0],[0,"PMIValidationProperties",1,0],[0,"ReferenceType",1,0],[0,"SettingsFile",1,0],[0,"SystemAttributes",1,0],[0,"UserDefinedAttributes",1,0],[0,"ValidationProperties",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.StepCreator = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.StepCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.StepCreator.ExportFromOption = Object.freeze({
    "DisplayPart" : "DisplayPart", "ExistingPart" : "ExistingPart"});

SPLM.StepCreator.EntityNameOption = Object.freeze({
    "LongName" : "LongName", "ShortName" : "ShortName"});

SPLM.StepCreator.ExternalReferenceStructureOption = Object.freeze({
    "Basic" : "Basic", "Nested" : "Nested"});

SPLM.StepCreator.ExportAsOption = Object.freeze({
    "Ap203" : "Ap203", "Ap214" : "Ap214", "Ap242" : "Ap242", "Ap242ED2" : "Ap242ED2"});

SPLM.StepCreator.ExportSolidsAndSurfacesAsOption = Object.freeze({
    "Precise" : "Precise", "Tessellated" : "Tessellated"});

SPLM.StepCreator.ExportConvergentAsOption = Object.freeze({
    "SplitPreciseAndTessellated" : "SplitPreciseAndTessellated", "Tessellated" : "Tessellated"});

SPLM.StepCreator.CsysrefEnum = Object.freeze({
    "Absolute" : "Absolute", "Wcs" : "Wcs", "SpecifiedCsys" : "SpecifiedCsys"});

export default SPLM;